import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformCommentsChatComponent } from './platform-comments-chat.component';
import { ProjectSubsectionSharedModule } from '../../../project-subsection/project-subsection-shared.module';
import { ConversationInterfaceComponent } from '@mtm/conversation-ui-angular';
import { SharedModule } from '../../../sub-modules/SharedModule';

@NgModule({
  declarations: [PlatformCommentsChatComponent],
  imports: [CommonModule, ProjectSubsectionSharedModule, SharedModule, ConversationInterfaceComponent],
  exports: [PlatformCommentsChatComponent],
})
export class PlatformCommentsChatModule { }


